// extracted by mini-css-extract-plugin
export default {"textOverview":"Overview_textOverview__udcs2","headingOverview":"Overview_headingOverview__Ugh0N"};